import {
  BodyWagesListParamsType,
  BodyWagesListResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyWagesList/getBodyWagesListQuery.type';
import { getBodyWagesListQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyWagesList/getBodyWagesListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyWagesListQueryOption = (params: BodyWagesListParamsType) =>
  queryOptions({
    queryKey: ['get_body-wages_list', params],
    queryFn: () => getBodyWagesListQueryFunction(params),
    select: (data: BodyWagesListResponseType) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        wages: data?.wages?.map((item) => ({ ...item })),
        id: data?.wages?.map((item) => ({ id: item?.id })),
        cartData: data?.wages?.map((item) => [
          {
            name: 'نوع تعمیر:',
            value: item?.title,
            id: item?.id,
          },
          {
            name: 'قیمت :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.price)} ریال`,
            id: item?.id,
          },
        ]),
      };
    },
  });
